import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenLayout from './HiddenLayout';
import Blocked from './Icons/Blocked';
const DefaultBlockedOverlay = (_param)=>{
    var { deviation } = _param, props = _object_without_properties(_param, [
        "deviation"
    ]);
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(HiddenLayout, _object_spread({
        deviation: deviation,
        icon: /*#__PURE__*/ React.createElement(Blocked, null),
        title: t('deviationview.blocked.default')
    }, props));
};
DefaultBlockedOverlay.displayName = 'DefaultBlockedOverlay';
export default DefaultBlockedOverlay;

//# sourceMappingURL=DefaultBlocked.js.map